import { normalize, schema } from 'normalizr';
import { EventViewModel } from 'stageclip-common';

import { NormalizedEvent } from '../../models/normalized/normalizedEvent';
import { ById } from '../../store/normalizedState';

import * as ClientNormalizers from './clientNormalizers';
import * as EntityNormalizers from './entityNormalizers';
import * as UserNormalizers from './userNormalizers';

const { Entity } = schema;

export interface NormalizedEvents extends UserNormalizers.NormalizedUsers, ClientNormalizers.NormalizedClients {
  events: ById<NormalizedEvent>;
  archivedEvents: ById<NormalizedEvent>;
}

export const eventSchema = new Entity('events', {
  assignee: UserNormalizers.userSchema,
});

export function normalizeEvent(data: EventViewModel): EntityNormalizers.NormalizedSingleEntity<NormalizedEvents> {
  return normalize(data, eventSchema);
}

export function normalizeEventsArray(
  data: EventViewModel[],
): EntityNormalizers.NormalizedEntityArray<NormalizedEvents> {
  return normalize(data, new schema.Array(eventSchema));
}
